module.exports = __webpack_public_path__ + "img/mistakesText6.426fc23f.png";